import { render } from "./construction-1.vue?vue&type=template&id=5db521cc&scoped=true"
import script from "./construction-1.vue?vue&type=script&lang=js"
export * from "./construction-1.vue?vue&type=script&lang=js"

import "./construction-1.vue?vue&type=style&index=0&id=5db521cc&scoped=true&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db521cc"]])

export default __exports__